import classNames from 'classnames';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { NavLink } from '../NavLink';
import { RestaurantSelector } from '../RestaurantSelector';
import { SidebarLink } from '../SideNavigation';

export interface INavProps {
  links: SidebarLink[];
  showOnPhone?: boolean;
  onLinkClick?: (link: SidebarLink) => void;
}

export const NavMenu: React.FC<INavProps> = ({ links, showOnPhone = false, onLinkClick }: INavProps) => {
  const location = useLocation();
  return (
    <div className={classNames(!showOnPhone ? 'md:block hidden' : 'block md:hidden', 'flex md:w-50 xl:w-80 md:flex-col md:fixed md:inset-y-0 md:mt-24')}>
      <div className="flex flex-col flex-grow md:border-r border-gray-200 md:pt-base h-full overflow-y-auto">
        <div className="flex-grow flex flex-col ">
          <nav className="flex-1 md:px-5 pb-small space-y-6 ">
            <RestaurantSelector />
            <div className=" w-4/5 mx-auto h-1 mt-20 border-t" />
            {links.map((link, index) => (
              <NavLink
                key={link.name + index}
                link={link.to}
                title={link.name}
                icon={link.icon}
                notification={link.notification}
                isActive={location.pathname === link.to}
                disabled={false}
                special={link.special}
                onClick={() => {
                  onLinkClick?.(link);
                }}
              />
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
};
